<div class="wrap">
  <div class="header">
    <h1>User management</h1>
    <div class="add_client_and_search_bar">
      <div
        class="add_Users"
        (click)="openDialogAddUsers()"
        (mouseleave)="show = false"
      >
        <span></span>
        <div class="fa-icon-container">
          <fa-icon [icon]="faPlus" class="faPlus"></fa-icon>
        </div>
      </div>
      <div class="search_bar">
        <input
          matInput
          (keyup)="applyFilter($event)"
          placeholder="Search a user"
          #input
        />
      </div>
    </div>
  </div>

  <div class="container">
    <mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <ng-container matColumnDef="username">
        <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>
        <mat-cell *matCellDef="let element" [style.text-align]="'center'">
          {{ element.username }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="client">
        <mat-header-cell *matHeaderCellDef> Customer </mat-header-cell>
        <mat-cell *matCellDef="let element" [style.text-align]="'center'">
          {{ element.client.name }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
        <mat-cell *matCellDef="let element" [style.text-align]="'center'">
          {{ element.email }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Gsm">
        <mat-header-cell *matHeaderCellDef> Phone </mat-header-cell>
        <mat-cell *matCellDef="let element" [style.text-align]="'center'">
          {{ element.gsm }}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="application">
        <mat-header-cell *matHeaderCellDef> Application </mat-header-cell>
        <mat-cell *matCellDef="let element" [style.text-align]="'center'">
          <ul>
            <li *ngFor="let a of element?.applications">
              {{ a?.application.ApplicationName }} - {{ a?.role.name }}
            </li>
          </ul>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="isActive">
        <mat-header-cell [style.width.%]="5" *matHeaderCellDef>
          Active/Inactive
        </mat-header-cell>
        <mat-cell
          [style.width.%]="5"
          *matCellDef="let element"
          [style.text-align]="'center'"
        >
          <mat-slide-toggle
            class="example-margin"
            (click)="activeDesactive(element.isActive, element.id)"
            [(ngModel)]="element.isActive"
            color="primary"
          >
          </mat-slide-toggle>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="password" class="mat-header">
        <mat-header-cell class="mat-header" *matHeaderCellDef>
          Password
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <fa-icon
            [icon]="faEnvelop"
            (click)="openDialogSendMailPassword(element.username)"
            matTooltip="Send mail for password"
          ></fa-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="notif">
        <mat-header-cell [style.width.%]="5" *matHeaderCellDef>
          Notifications
        </mat-header-cell>
        <mat-cell [style.width.%]="5" *matCellDef="let element">
          <fa-icon
            [icon]="faNotif"
            (click)="openDialogNotif(element)"
            matTooltip="Configure your notifications"
          ></fa-icon>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Edit">
        <mat-header-cell [style.width.%]="5" *matHeaderCellDef>
          Update
        </mat-header-cell>
        <mat-cell [style.width.%]="5" *matCellDef="let element">
          <fa-icon
            [icon]="faPen"
            (click)="openDialogEditUsers(element)"
            matTooltip="Edit user"
          ></fa-icon>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
</div>
